'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Line height ratios (in em)
var HEADER_LINE_HEIGHT = exports.HEADER_LINE_HEIGHT = 1.2;
var TEXT_LINE_HEIGHT = exports.TEXT_LINE_HEIGHT = 1.6;

var ROOT = exports.ROOT = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://decisiv.github.io/base-components';


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/constants.js
// module id = 132
// module chunks = 2